import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-250px" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "mt-3" }
const _hoisted_4 = { class: "flex items-center justify-end gap-4 mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectAsync = _resolveComponent("SelectAsync")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.options, (item) => {
      return (_openBlock(), _createElementBlock("div", { key: item }, [
        _createElementVNode("p", {
          class: _normalizeClass(item.label === $setup.selectedOptions?.label ? 'text-sm font-normal text-primary cursor-pointer' : 'text-sm text-grey cursor-pointer'),
          onClick: ($event: any) => ($setup.selectOptionAct(item))
        }, _toDisplayString(item.label), 11, _hoisted_2)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-xs" }, "Cari Berdaarkan Dokumen", -1)),
      _createVNode(_component_SelectAsync, {
        modelValue: $setup.selectedDocumentType,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedDocumentType) = $event)),
        inputId: `position`,
        endpoint: $setup.documentTypesEndpoint,
        classname: 'custom-select',
        fieldLabel: (v) => `${v.name}`,
        fieldValue: 'id',
        clearable: false,
        searchFields: ['name'],
        placeholder: `Pilih dokumen`,
        onChange: _cache[1] || (_cache[1] = (val) => $setup.selectedOptions = null)
      }, null, 8, ["modelValue", "endpoint", "fieldLabel"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        class: "btn-primary mr-1",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.applySearch($event)))
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("Apply")
        ])),
        _: 1,
        __: [4]
      })
    ])
  ]))
}